import CustomHeader from "../CustomHeader";
import { useEffect, useRef, useState } from "react";
import { IRingData } from "../../../types/IPlayerDetail";
import FormattedNumber from "../../FormattedNumber";
import SingleRingChart from "../SingleRingChart";
import CustomTable from "../../../ui/Table";
import { IInjuryChart, IInjuryRecord, IMedicalHistrory } from "../../../types/IInjuryData";
import InjuryBarChart from "./InjuryBarChart";
import LabelText from "../../../ui/LabelText";
import SecondaryButton from "../../../ui/SecondaryButton";
import { StatCard } from "../../../styled-components/AttributesStyles";
import LabelNumber from "../../../styled-components/LabelNumber";
import { EmptyData } from "./Tags";


interface InjuryRecordProps {
  injuryData: IInjuryRecord | undefined;
}

export const InjuryRecord: React.FC<InjuryRecordProps> = ({ injuryData }) => {
  const tableRef = useRef<null | HTMLDivElement>(null);
  const [isTableOpen, setIsTableOpen] = useState(false);
  const [InjuryRingData, setInjuryRingData] = useState<IRingData[]>([]);
  const [InjuryChartData, setInjuryChartData] = useState<IInjuryChart[]>()
  const [medicalHistryData, setMedicalHistoryData] = useState<IMedicalHistrory[]>([])

  useEffect(() => {
    if (injuryData !== undefined) {
      const formattedData = injuryData?.medicalHistory?.map(item => ({
        ...item,
        // season: `${item.season.slice(2, 4)}/${item.season.slice(7)}`,
        season: `${item.season}`,
        from: new Date(item.from).toLocaleDateString('en-GB'),
        to: item.to ? new Date(item.to).toLocaleDateString('en-GB') : 'Unknown return date'
        // from: moment(item.from).format('DD/MM/YY'),
        // to: moment(item.to).format('DD/MM/YY') 
      }));
      setMedicalHistoryData(formattedData!);
      setInjuryRingData([
        { name: "Available", percent: injuryData?.available!, color: "#00D1A8" },
      ]);
      setInjuryChartData(injuryData?.injuryChart)
    }

  }, [injuryData]);

  const handleClickInjuryList = () => {
    setIsTableOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isTableOpen) {
      tableRef.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [isTableOpen])

  if (!medicalHistryData || medicalHistryData.length === 0)
    return (
      <div className="injury-container">
        <CustomHeader title="Injury Record" />
        <button className="data-not-available-btn">Data not currently available</button>
      </div>
    )

  // Define the headers and data mapping for specific columns
  const specificHeaders = [
    "Date",
    "From Club",
    "To Club",
    "Free Transfer",
    "Transfer Fee"
  ];

  // Determine the headers and rows to display
  const headers = Object.keys(medicalHistryData[0]).map(key => key.charAt(0).toUpperCase() + key.slice(1));

  const rows = medicalHistryData;



  return (
    <div className="injury-container">
      <CustomHeader title="Injury Record" />
      {/* <div className="injury-detail">
        <div className="overall-left">
          <SingleRingChart data={InjuryRingData} type="dualRing" />
        </div>
        <div className="overall-right single-overall">
          <StatCard className="injury-card">
            <LabelText className="player-search-text">Games Missed</LabelText>
            <div className="games-value">
              <FormattedNumber number={injuryData?.gamesMissed?.toString()} />
              <LabelNumber className="total-games">/{injuryData?.totalGames}</LabelNumber>
            </div>
            <LabelNumber className="injury-text">THROUGH INJURY</LabelNumber>
          </StatCard>
        </div>
      </div> */}
      <div className="injury-record-container">
        <div className="injury-content">
            <div className="injury-detail-content">
              <LabelText className="player-given-name">% matches missed through injury</LabelText>
              <div><LabelNumber className="injury-number">{injuryData?.injured}</LabelNumber>
              <LabelNumber className="player-card-value">%</LabelNumber></div>

            </div>
        </div>
        <div className="injury-content">
            <div className="injury-detail-content">
              <LabelText className="player-given-name">Total games missed</LabelText>
              <div><LabelNumber className="injury-number">{injuryData?.gamesMissed}</LabelNumber>
              <LabelNumber className="player-card-value">/{injuryData?.totalGames}</LabelNumber></div>
            </div>
        </div>
      </div>

      <InjuryBarChart data={InjuryChartData} />

      <div className="injury-list-container">
        <SecondaryButton onClick={handleClickInjuryList} label="Show full injury List"
          iconType={isTableOpen ? "keyboardarrowup" : "keyboardarrowdown"} />
        {isTableOpen && (
          <>
            <LabelText className="player-detail-given-name" style={{ alignSelf: 'flex-start' }}>Medical history</LabelText>
            <CustomTable data={medicalHistryData} showSpecificColumns={false} headers={headers} rows={rows} />
          </>
        )}
        <p ref={tableRef}></p>
      </div>
    </div>
  );
};

export default InjuryRecord;
